import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { formatDate, statusBadgeClass, statusLabel } from "../../lib/format";
import { KPI, Card, Loading } from "../../components/UI";
import { Wrench, ClipboardCheck } from "lucide-react";

export default function MaintenanceDashboard() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = () => api.get("/maintenance").then(r => setTickets(r.data)).finally(() => setLoading(false));
  useEffect(() => { reload(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/maintenance/${id}`, { status });
      toast.success(`Ticket marked ${statusLabel(status)}`);
      reload();
    } catch (e) { toast.error("Failed to update"); }
  };

  if (loading) return <Loading/>;
  const open = tickets.filter(t => ["assigned","in_progress"].includes(t.status));
  const done = tickets.filter(t => ["completed","closed"].includes(t.status));

  return (
    <div className="space-y-6">
      <div className="fade-up">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#C9A227]">MAINTENANCE STAFF</div>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#1A2E24]">My Assigned Tickets</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <KPI label="Active" value={open.length} icon={Wrench}/>
        <KPI label="Completed" value={done.length} icon={ClipboardCheck}/>
        <KPI label="Total" value={tickets.length} icon={Wrench}/>
      </div>

      <Card title="Active Tickets">
        {open.length === 0 ? <div className="text-sm text-[#5E7166] py-6 text-center">No active tickets.</div> :
          <ul className="divide-y divide-[#E5EBE8]">
            {open.map(t => (
              <li key={t.id} className="py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-sm" data-testid={`mt-ticket-${t.id}`}>
                <div>
                  <div className="font-semibold">{t.title}</div>
                  <div className="text-xs text-[#5E7166]">{t.tenant?.full_name} • {t.unit?.unit_name} • {formatDate(t.created_at)}</div>
                  <div className="text-xs text-[#1A2E24] mt-1">{t.description}</div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={statusBadgeClass(t.status)}>{statusLabel(t.status)}</span>
                  {t.status === "assigned" && <button onClick={() => updateStatus(t.id, "in_progress")} className="btn-outline-emerald text-xs">Start</button>}
                  {t.status === "in_progress" && <button onClick={() => updateStatus(t.id, "completed")} className="btn-gold text-xs">Complete</button>}
                </div>
              </li>
            ))}
          </ul>}
      </Card>

      <Card title="Completed">
        {done.length === 0 ? <div className="text-sm text-[#5E7166] py-4">None yet.</div> :
          <ul className="divide-y divide-[#E5EBE8]">
            {done.map(t => (
              <li key={t.id} className="py-2 flex items-center justify-between text-sm">
                <span>{t.title} <span className="text-xs text-[#5E7166]">— {t.unit?.unit_name}</span></span>
                <span className={statusBadgeClass(t.status)}>{statusLabel(t.status)}</span>
              </li>
            ))}
          </ul>}
      </Card>
    </div>
  );
}
